<template>
  <div class="alerts-container" v-if="false">
    <el-alert
      v-for="(msg,index) in formatedMessage"
      :key="index"
      style="margin: 2px;"
      :title="msg[0].value"
      :type="msg[0].type && msg[0].type.toLowerCase()"
      show-icon
      @close="dismiss(index)"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from 'pinia';
import { mainStore } from 'operass-spa/src/store/index';
// import { Message } from 'element-ui';

export default {
  name: 'CcAlert',
  computed: {
    ...mapState(mainStore, ['messages']),

    formatedMessage() {
      return this.messages;
    },
  },
  methods: {
    ...mapActions(mainStore, ['resetMessages', 'removeMessage']),
    dismiss(index) {
      this.removeMessage(index);
    },
  },
};
</script>

<style scoped>
  .alerts-container {
    padding-top: 16px;
    padding-bottom: 5px;
  }
</style>
